"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timeout = void 0;
exports.aTimeoutOf = aTimeoutOf;
/**
 * This class is intended to be created via `aTimeoutOf()`.
 * Its goal is to provide a human-friendly syntax for pausing for a given amount of time.
 */
class Timeout {
    promise;
    constructor(promise) {
        this.promise = promise;
    }
    hasPassed() {
        return this.promise;
    }
}
exports.Timeout = Timeout;
/**
 * Returns a new Timeout object
 *
 * @param ms duration (in millisecond) for the timeout to occur
 */
function aTimeoutOf(ms) {
    return new Timeout(new Promise(resolve => setTimeout(resolve, ms)));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWlzYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXNjLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQWlCQSxnQ0FFQztBQW5CRDs7O0dBR0c7QUFDSCxNQUFhLE9BQU87SUFDVztJQUE3QixZQUE2QixPQUFzQjtRQUF0QixZQUFPLEdBQVAsT0FBTyxDQUFlO0lBQUcsQ0FBQztJQUV2RCxTQUFTO1FBQ1AsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFBO0lBQ3JCLENBQUM7Q0FDRjtBQU5ELDBCQU1DO0FBRUQ7Ozs7R0FJRztBQUNILFNBQWdCLFVBQVUsQ0FBQyxFQUFVO0lBQ25DLE9BQU8sSUFBSSxPQUFPLENBQUMsSUFBSSxPQUFPLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxVQUFVLENBQUMsT0FBTyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQTtBQUNyRSxDQUFDIn0=